
import { Vue, Component, Prop } from 'vue-property-decorator';
import { MoovDropInput, MoovDropInputProperties } from '@/interfaces/moov';

@Component
export default class MoovInputWrapper extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;

  @Prop({ type: String, default: '' }) readonly invalidMsg!: string;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  @Prop({ type: Object, default: () => {} })
  readonly inputProperties!: Partial<MoovDropInputProperties>;

  error = '';

  isDirty = false;

  async mounted() {
    await this.$nextTick();

    const input = this.$el.querySelector('.input > *') as MoovDropInput;

    Object.assign(input, this.inputProperties);

    input.onChange = () => {
      this.error = !input.validity.valid ? this.invalidMsg || input.validationMessage : '';
      this.$emit('change');
    };

    input.onInput = () => {
      this.error = '';
    };

    input.onFocus = () => {
      this.isDirty = true;
    };
  }
}
